import { Model } from "./model";
import { Project } from "./project";
import { Track } from "./track";
import { defaultConfig, TrackerConfig } from "./trackerConfig";
import { User } from "./user";

export const defaultTracker: Tracker = {
    id: '',
    name: '',
    batteryLevel: -1,
    uuid: '',
    lastTrack: {} as Track,
    lastUpdate: Date.now(),
    projects: [],
    selected: false,
    settings: {},
    config: defaultConfig,
    project: "",
    loadingStats: false
};


export interface Tracker {
    id: string;
    name: string;
    picture?: string;
    batteryLevel: number; // default: -1
    shackleBattery?: number;
    type?: string; // e.g., 'kyd', 'gps', 'sigfox'
    serial?: string;
    mac?: string;
    uuid: string;
    lastTrack?: Track;
    collider?: Record<string, any>;
    config?: TrackerConfig;
    settings?: any;
    // Whether `settings` is known to actually be on the physical sensor (a real BLE read/write
    // confirmed it) - set by the mobile app, reset to false by the web whenever it saves new
    // settings (see TrackerConfigTool.saveSettings()), read here to show a "received by sensor"
    // status (kyd.component).
    settingsConfirmed?: boolean;
    // Ephemeral live status set/cleared by the mobile app while it attempts a Bluetooth
    // connection to this device (see ble-detail.page.ts's pushConnectingStatus()) - read-only
    // here, never written from the web. connectingAt lets a stale flag (the app crashed mid-
    // attempt without clearing it) be treated as expired instead of trusted forever.
    connecting?: boolean;
    connectingAt?: string | null;
    // The raw, unprocessed value of every KYD BLE characteristic, keyed by characteristic
    // name - exactly what the mobile app's own "Expert" mode already shows, pushed here too
    // since the site has no way to read a sensor directly (see unifield-mobile-2's
    // ble-detail.page.ts pushSettingsToUnifield()). Read-only here, never written from the web.
    rawData?: Record<string, any> | null;
    rawDataAt?: string | null;
    description?: string;
    version?: string;
    comment?: string;
    // Per-device offline threshold (seconds) - falls back to the linked TrackerConfig's own
    // offlineDelay when unset (see isWithinOfflineDelay in tools.ts/tracker.tools.ts), so a
    // tracker with no config link (KYD and, since the config-per-device redesign, every other
    // type edited this way) still gets one.
    offlineDelay?: number;
    lastUpdate: string | number; // default: Date.now
    project?: Project|string;
    projects: Project[]|string[];
    //front use
    status?:string;
    selected:boolean;
    colorName?:string;
    sorted?: boolean;
    stats?: string;
    unitId?: string;
    color?: string;
    loadingStats?: boolean;
}

export interface PostTracker {
    name: string;
    project?: string;
    picture?: string;
    batteryLevel?: number; // default: -1
    shackleBattery?: number;
    type?: string; // e.g., 'kyd', 'gps', 'sigfox'
    serial?: string;
    mac?: string;
    description?: string;
    version?: string;
    comment?: string;
    model?: Model | string;
    collider?: Record<string, any>;
    config?: string;
    settings?: any;
    parent?: string;
    children?: string[];
    editedBy?: string;
    lastUpdate?: string | number; // default: Date.now
    projects?: string[];
}

export interface PutTracker {
    id: string;
    uuid: string;
    name?: string;
    picture?: string;
    batteryLevel?: number; // default: -1
    shackleBattery?: number;
    type?: string; // e.g., 'kyd', 'gps', 'sigfox'
    serial?: string;
    mac?: string;
    model?: string;
    collider?: Record<string, any>;
    config?: string;
    description?: string;
    version?: string;
    comment?: string;
    offlineDelay?: number;
    settings?: any;
    settingsConfirmed?: boolean;
    parent?: Tracker | string;
    children?: string[];
    editedBy?: User | string;
    lastUpdate?: string | number; // default: Date.now
    project?: string;
    projects?: string[];
}
